<script lang="ts">
	import { getTranslate } from '@tolgee/svelte';
	import type { EntryIcon } from '../Entries/Entry';
	import FeatureEntry from '../Entries/Entry.svelte';

	const { t } = getTranslate();

	export let titleTolgeeKey: string;
	export let features: Array<{ icon: EntryIcon; text: string }>;
</script>

<div class="flex flex-col items-center justiy-center gap-2 whitespace-nowrap">
	<div class="">{$t(titleTolgeeKey)}</div>
	{#each features as feature}
		<FeatureEntry icon={feature.icon} text={feature.text} />
	{/each}
</div>
